module.exports = __webpack_public_path__ + "img/mac-broadcast@2x.30bb687d.png";